import { SvgBase } from "../svg.base";

export const Favorite: React.FC<{ size?: number }> = ({ size }) => (
    <SvgBase
        width={"" + (size || 24)}
        height={"" + (size || 24)}
        viewBox="0 0 24 24"
    >
       <path d="M7.249 20.973c-.38.005-.74-.15-.987-.425a1.182 1.182 0 0 1-.29-.996l.798-4.637-3.398-3.301a1.182 1.182 0 0 1-.306-1.247c.152-.437.55-.755 1.028-.821l4.674-.672 2.076-4.173C11.054 4.273 11.505 4 12 4c.495 0 .945.273 1.156.701l2.076 4.173 4.674.672c.478.066.876.384 1.028.821.153.438.035.92-.306 1.247l-3.417 3.3.799 4.638c.091.468-.11.945-.518 1.22a1.327 1.327 0 0 1-1.354.08L12 18.666l-4.138 2.16c-.19.095-.4.145-.613.146zM12 17.361c.107 0 .212.025.307.074l4.47 2.318-.881-4.966a.593.593 0 0 1 .179-.525l3.64-3.527-5.014-.72a.636.636 0 0 1-.479-.341L12 5.226 9.778 9.698a.636.636 0 0 1-.48.342l-5.013.714 3.64 3.526c.138.134.204.32.18.507l-.856 4.966 4.47-2.318A.662.662 0 0 1 12 17.36z" fill="currentColor" fillRule="nonzero"/>
    </SvgBase>
);



